module.exports = __webpack_public_path__ + "static/media/18_Maf_NuestroEquipo_JoseUribe.c.e4f39657.png";